import { Link } from "react-router-dom";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "./dialog";

const NewOrder = ({ trigger }: { trigger: React.ReactNode }) => {
  return (
    <Dialog>
      <DialogTrigger asChild>{trigger}</DialogTrigger>
      <DialogContent className="sm:max-w-md min-w-[600px] py-4 px-6 gap-5 bg-[#F0F4FC]" aria-describedby={undefined}>
        <DialogHeader className="mb-7 items-center flex flex-col">
          <DialogTitle className="font-bold text-2xl">Erstelle einen neuen Auftrag</DialogTitle>
          <DialogDescription>Möchtest Du eine Vorlage nutzen? </DialogDescription>
        </DialogHeader>
        <div className="flex gap-4 w-full">
          <DialogClose asChild>
            <Link
              to="/order/create"
              className="rounded-lg bg-white flex items-center justify-center w-1/2 h-4/5 p-2 relative"
            >
              <img src={"/without-template.png"} alt="template" className="h-full w-full opacity-75" />
              <div className="absolute top-0 left-0 w-full h-full flex items-center justify-center">
                <p className="text-black text-lg font-bold">Ohne Vorlage</p>
              </div>
            </Link>
          </DialogClose>
          <DialogClose asChild>
            <Link
              to="/templates"
              className="rounded-lg bg-white flex items-center justify-center w-1/2 h-4/5 p-2 relative"
            >
              <img src={"/with-template.png"} alt="template" className="h-full w-full" />
              <div className="absolute top-0 left-0 w-full h-full flex items-center justify-center">
                <p className="text-white text-lg font-bold">Mit Vorlage</p>
              </div>
            </Link>
          </DialogClose>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default NewOrder;
